const TRACTION_INTERNAL_DOMAINS = [
  'tractionapps.co'
];

export function isTractionInternalEmail(email) {
  const domain = (email.split('@')[1] || '').toLowerCase().trim();
  return TRACTION_INTERNAL_DOMAINS.includes(domain);
}
